module.exports = __webpack_public_path__ + "img/marker_four_green2.d15c8344.png";